import { render, staticRenderFns } from "./tzsbksslink.vue?vue&type=template&id=db993008"
import script from "./tzsbksslink.vue?vue&type=script&lang=js"
export * from "./tzsbksslink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports